import type {
  components,
  paths,
  RegulatoryDutyCategory
} from "../../types/api.types";

export type StartPageTile = components["schemas"]["StartPageTile"];

export type StartPageInvoices = components["schemas"]["NumberOfInvoices"];

export type StartPageElectricityTax =
  paths["/api/start-page/stromsteuer"]["get"]["responses"][200]["content"]["application/json"];

export type StartPageDeliveredElectricity =
  components["schemas"]["DeliveredElectricity"];

export type StartPageProducedElectricity =
  paths["/api/start-page/produced-electricity"]["get"]["responses"][200]["content"]["application/json"];

export type StartPageEEG6 = components["schemas"]["Paragraph6EEGParticipation"];

export type StartPageCO2Savings = components["schemas"]["Co2Savings"];

export type StartPageSite = components["schemas"]["StartPageSite"];

export interface StartPageOnboardingProgress {
  project_id: string;
  project_name: string;
  site_id: number;
  site_name: string;
  phase_name: string;
}

export type StartPageCompany = components["schemas"]["Person"];

export enum StartPageRegulatoryTodoTag {
  DUE = "due",
  NEW = "new"
}

export interface StartPageRegulatoryTodo {
  created: string;
  regulatory_duty_category: RegulatoryDutyCategory;
  due_date: string;
  id: number;
  name: string;
  person_id: number | null;
  person_name: string | null;
  project_id: string;
  project_name: string;
  tag: StartPageRegulatoryTodoTag;
}

export type SiteSetupProcessTileData =
  components["schemas"]["SiteSetupProcessTileData"];
